var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slider"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68482 2.24797L20.6588 2.24707C20.982 2.24705 21.2802 2.42049 21.44 2.70133C21.5998 2.98216 21.5965 3.32716 21.4314 3.60492L12.173 19.183C11.9863 19.4971 11.628 19.6669 11.2667 19.6125C10.9053 19.5581 10.6129 19.2904 10.527 18.9352L8.35867 9.97261L2.05546 3.78816C1.79489 3.53251 1.71486 3.14464 1.85294 2.80672C1.99102 2.46881 2.31978 2.24799 2.68482 2.24797ZM10.2062 9.96547L11.7552 16.368L18.1896 5.54158L10.2062 9.96547ZM17.1826 4.04465L4.88393 4.04526L9.32252 8.40023L17.1826 4.04465Z",
    fill: "#C0C0C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteShare);
export default __webpack_public_path__ + "static/media/white_share.9db0cbdcb6a1432fdd1b2426c7ad8555.svg";
export { ForwardRef as ReactComponent };